export default function MenuIcon({src}: { src: string }) {
	return (
		<img src={src} alt="" style={{width: "18px", height: "18px", marginRight: "12px"}}/>
	)
}
